import { ApiGenericResponse } from "../../ApiGenericResponse";
import { ApiResponse } from "../../ApiResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";

export class DisableMFACommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + "/usermanagement";
    httpVerb: HttpVerbType = "delete";
    username: string;

    constructor(username: string) {
        super();
        this.endPoint += `/${username}/mfa`;
    }

    public async execute(): Promise<ApiResponse> {
        var res = await this.executeCommand();
        return ApiResponse.FromAxiosResponse(res);
    }
}
